import Dexie, { Table } from 'dexie';

export interface CommentColumn {
  id: number;
  taskId: number;
  versionId: number;
  comment: string;
}

export class MySubClassedDexie extends Dexie {
  comments!: Table<CommentColumn>;

  constructor() {
    super('myDatabase');
    this.version(1).stores({
      comments: 'id, comment, taskId, versionId', // Primary key and indexed props
    });
  }
}

export const db = new MySubClassedDexie();
